// utils/base64Json.ts

/**
 * Encode bất kỳ object nào thành base64 JSON string
 */
export function encodeBase64Json<T = unknown>(obj: T): string {
  try {
    const json = JSON.stringify(obj)
    return Buffer.from(json).toString('base64')
  } catch (err) {
    console.error('encodeBase64Json error:', err)
    return ''
  }
}

/**
 * Decode base64 JSON string thành object
 */
export function decodeBase64Json<T = unknown>(base64: string): T | null {
  try {
    const json = Buffer.from(base64, 'base64').toString('utf-8')
    return JSON.parse(json)
  } catch (err) {
    console.error('decodeBase64Json error:', err)
    return null
  }
}
